/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React TS Base Styles
import colors from "dashboard-template/assets/theme-dark/base/colors";

const { dark } = colors;

// types
type Types = any;

const Grid: Types = {
  styleOverrides: {
    root: {
      "&.btn-close-modal": {
        backgroundColor: dark.focus,
        backgroundClip: "border-box",
        WebkitBackgroundClip: "border-box",
        border: "0 solid rgba(0, 0, 0, 0.125)",
        borderRadius: "0.75rem",
        boxShadow: `
          0rem 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1),
          0rem 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.06)
        `,
        overflow: "visible",
        padding: "1rem",
        "& > div": {
          marginTop: 0,
        },
      },
    },
  },
};

export default Grid;
